import { Truck } from "lucide-react";
import { dataBR } from "@/lib/api";
import { EmptyState, StatusPill, Surface } from "@/components/ds";

const STAGE_TONE = {
  PENDENTE: "warning",
  PAGO: "info",
  EM_PRODUCAO: "info",
  PRONTO: "success",
  ENTREGUE: "success",
  CANCELADO: "danger",
};

/** Acompanhamento pelos status reais do pedido. O TR3ND OS não registra transportadora. */
export const CreatorDeliveries = ({ data }) => {
  const orders = (data.orders || []).filter((o) => o.status !== "CANCELADO");
  if (orders.length === 0)
    return (
      <EmptyState
        icon={Truck}
        title="Nenhuma entrega em andamento"
        description="Os pedidos com produtos seus aparecem aqui com a etapa atual."
        testid="creator-deliveries-empty"
      />
    );

  return (
    <div className="space-y-3" data-testid="creator-deliveries">
      {orders.map((o) => (
        <Surface key={o.number} className="p-4" data-testid={`creator-delivery-${o.number}`}>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <div className="min-w-0">
              <p className="font-display text-sm">{o.number}</p>
              <p className="text-[11px] text-muted-foreground">
                Atualizado em {dataBR(o.updated_at || o.created_at)}
              </p>
            </div>
            <StatusPill tone={STAGE_TONE[o.status] || "info"}
                        testid={`creator-delivery-stage-${o.number}`}>
              {o.status_label}
            </StatusPill>
          </div>
          <ul className="mt-2.5 space-y-0.5 text-xs text-muted-foreground">
            {o.items.map((i, idx) => (
              <li key={idx}>
                {i.quantity}x {i.name}
                {i.variation_name ? ` · ${i.variation_name}` : ""}
              </li>
            ))}
          </ul>
        </Surface>
      ))}
      <p className="text-[11px] text-muted-foreground">
        O acompanhamento usa as etapas do pedido no TR3ND OS. Código de rastreio e transportadora
        não são registrados no sistema hoje, por isso não aparecem aqui.
      </p>
    </div>
  );
};
